import { useEffect, useContext, useState } from "react";

import Page from "../../../manager/components/page/page";
import "./datamodel-graph.scss";
import Spinner from "../../../shared/components/spinner/spinner";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData } from "../../../shared/utils/api";
import { IObject, validateLoadingStatusNew } from "../../../shared/utils/utils";
import NetworkGraph, { INetworkGraphEdge, INetworkGraphNode } from "../../../manager/components/network-graph/network-graph";

const DatamodelGraph = () => {
  const authCtx = useContext(AuthContext);

  const { sendRequest: getDatamodelGraph, status: getDatamodelGraphStatus, data: getDatamodelGraphData, error: getDatamodelGraphError } = useHttp(getAllData, false, authCtx.token, "default", "platform");

  const [nodes, setNodes] = useState<INetworkGraphNode[]>([]);
  const [edges, setEdges] = useState<INetworkGraphEdge[]>([]);

  useEffect(() => {
    getDatamodelGraph("datamodel/network");
  }, []);

  useEffect(() => {
    if (getDatamodelGraphStatus === "completed" && !getDatamodelGraphError && getDatamodelGraphData) {
      const { nodes, edges } = getDatamodelGraphData;
      setNodes(nodes.map((n: IObject) => ({
        data: {
          id: n.id,
          label: `${n.name} (${n.type})`,
          type: n.type,
          type_detail: n.type 
        }
      })));
      setEdges(edges.map((e: IObject) => ({ data: {
        source: e.source,
        target: e.target,
        label: e.label
      } })));
    }
  }, [getDatamodelGraphStatus, getDatamodelGraphError, getDatamodelGraphData]);

  return (
    <Page title={{text: "Data model graph"}}>
      <div className="datamodelGraph">
        {validateLoadingStatusNew([getDatamodelGraphStatus]) && <Spinner />}
        <NetworkGraph nodes={nodes} edges={edges} />
      </div>
    </Page>
  );
};

export default DatamodelGraph;